<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path + index">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{
          getLangMetaTitle(item.meta) }}</span>
        <!--          <a v-else @click.prevent="handleLink(item)">{{ generateTitle(item.meta.title) }}</a>-->
        <span v-else>{{ getLangMetaTitle(item.meta) }}</span>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
// import { generateTitle } from '@/utils/i18n'
import pathToRegexp from 'path-to-regexp'
import lodash from 'lodash'
import { mapGetters } from 'vuex'
import { getLangMetaTitle } from '@/utils/langUtil'

export default {
  data() {
    return {
      levelList: null
    }
  },
  computed: {
    ...mapGetters([
      'language'
    ]),
    isZh() {
      return this.language === 'zh'
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getLangMetaTitle,
    generateTitle() {

    },
    getBreadcrumb() {
      const matched = this.$route.matched.filter(item => item.name)
      console.log('matched', matched)
      let bread = []
      const first = matched[0]
      if (first && !['Dashboard'.toLocaleLowerCase(), 'index'].includes(first.name.trim().toLocaleLowerCase())) {
        bread = [{ path: '/dashboard', meta: { title: '首页', enTitle: 'Dashboard', jaTitle: '看板', ruTitle: 'Главная страница', thTitle: 'หน้าหลัก', viTitle: 'Trang chủ' }}]
        if (first.parent) {
          bread = bread.concat(first.parent)
        }
      }
      bread = bread.concat(matched)

      this.levelList = bread.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 40px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
